import { ISettingsData, SettingsView } from '@fantasmagames/slot/src/modules/mainmenu/settingsmenu/SettingsView';
import { GenericButton } from '@fantasmagames/slot/src/modules/popupmenus/GenericButton';

export class RecodeSettingsView extends SettingsView {
	public init(): void {
		this._spacebarActive = false;

		super.init();
	}

	public setupSettingsViewComponents(previousSettings: ISettingsData): void {
		super.setupSettingsViewComponents(previousSettings);

		this.setupButtonsGaming();
	}

	protected onResponsibleGamingPressed(): void {
		(window as any).V.API.Core.launchResponsibleGaming();
	}

	protected onPlayForRealPressed(): void {
	}

	protected setupButtonsGaming(): void {
		const hasLinkToResponsibleGaming: boolean = (window as any).V.API.Core.getCasinoConfig().featureConfig.responsibleGamingLink;

		if (hasLinkToResponsibleGaming) {
			const responsibleGamingButton: GenericButton = this.addSettingsMenuLongButton(
				'SETTINGS_RESPONSIBLE_GAMING',
				'SETTINGS_TITLE_TEXTS',
				this.onResponsibleGamingPressed,
			);

			const responsibleText: string =
				this.translator.getObject('BaseStrings', 'generic', 'g_responsiblegaming') || 'RESPONSIBLE GAMING';
			responsibleGamingButton.changeText(responsibleText.toUpperCase());

			////////////////////////////////////////////////////////////////////
			// According to Recode: Play for real button is unwanted on QF games.
			////////////////////////////////////////////////////////////////////
			//
			// if ((window as any).V.API.Core.getCasinoState().player.isPracticePlay) {
			// 	this.addSettingsMenuLongButton('SETTINGS_PLAYFORREAL', 'SETTINGS_TITLE_TEXTS', this.onPlayForRealPressed);
			// 	const playForRealText: string = this.translator.getObject('BaseStrings', 'generic', 'g_playforreal') || 'PLAY FOR REAL';
			// 	responsibleGamingButton.changeText(playForRealText.toUpperCase());
			// }

			responsibleGamingButton.scaleTextToFitContainer(0.85);
		}
	}

	protected addSettingsMenuLongButton(containerBoneName: string, offsetBoneName: string, onPressedCallback: Function): GenericButton {
		const spriteButton = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'LONG_BUTTON.png'));
		const bone = this._spineLayout.skeleton.findBone(containerBoneName).data;

		const button: GenericButton = new GenericButton(onPressedCallback.bind(this), this.textStyles.smallButtonBaseStyle);
		spriteButton.anchor.set(0.5, 0.5);
		button.setFrames(spriteButton);

		this.container.addChild(button);
		const yOffset = this._spineLayout.skeleton.findBone(offsetBoneName).data.y;
		this.setTransform(button, bone, 0, yOffset);

		return button;
	}

	protected setupCheckboxes(): void {
		const yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
		const xOffset = 0;

		const spineName = 'SETTINGS_CONFIG_BUTTON.json';

		this._musicToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_MUSIC', this.musicActive, xOffset, yOffset);
		this._soundToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SOUNDEFFECTS', this.soundActive, xOffset, yOffset);
		this._skipIntroToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SKIPINTRO', this.skipIntroActive, xOffset, yOffset);
	}

	protected setupCheckboxesEvents(): void {
		this._musicToggle.interactive = this._musicToggle.buttonMode = true;
		this._soundToggle.interactive = this._soundToggle.buttonMode = true;
		this._skipIntroToggle.interactive = this._skipIntroToggle.buttonMode = true;

		this._musicToggle.on('mousedown', this.onMusicToggle.bind(this));
		this._soundToggle.on('mousedown', this.onSoundToggle.bind(this));
		this._skipIntroToggle.on('mousedown', this.onSkipIntroToggle.bind(this));
	}

	protected setupText(): void {
		const yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;

		const musicTextBone = this._spineLayout.skeleton.findSlot('SETTINGS_TEXT_MUSIC').bone.data;
		musicTextBone.x -= 200;

		this._musicText = this.setupSingleText(
			'MUSIC',
			{
				name: 'SETTINGS_TEXT_MUSIC',
				bone: true,
			},
			0,
			yOffset,
			musicTextBone.x,
			null,
		);
		this._soundText = this.setupSingleText(
			'SOUND',
			{name: 'SETTINGS_TEXT_SOUNDEFFECTS', bone: true},
			0,
			yOffset,
			musicTextBone.x,
			null,
		);

		this._skipIntroText = this.setupSingleText(
			'SKIP INTRO',
			{name: 'SETTINGS_TEXT_SKIPINTRO', bone: true},
			0,
			yOffset,
			musicTextBone.x,
			null,
		);

	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/settingsmenu/recode/RecodeSettingsView.ts